import { Tags as EverestTags } from '~/api/everest/tags.autogen';
import { everest } from '~/redux/api/everest';

import { api } from '../createApi';
import { TagType } from '../TagType';

export const TAG_WORKFLOWS_BY_LIST = { type: TagType.Workflows, id: 'LIST' };

const EVEREST_WORKFLOWS_LIST_TAG = {
  type: EverestTags.workflows,
  id: 'LIST',
} as const;
const EVEREST_ROUTING_LIST_TAG = {
  type: EverestTags.routing,
  id: 'LIST',
} as const;

interface MutationLifecycle {
  dispatch: (action: unknown) => unknown;
  queryFulfilled: Promise<unknown>;
}

function invalidateAvailableWorkflowsOnSuccess(
  _arg: unknown,
  { dispatch, queryFulfilled }: MutationLifecycle,
) {
  queryFulfilled.then(
    () => dispatch(api.util.invalidateTags([TAG_WORKFLOWS_BY_LIST])),
    () => {},
  );
}

api.enhanceEndpoints({
  addTagTypes: [TagType.Workflows],
  endpoints: {
    createWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST],
      onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        queryFulfilled.then(
          () =>
            dispatch(everest.util.invalidateTags([EVEREST_WORKFLOWS_LIST_TAG])),
          () => {},
        );
      },
    },
    getAvailableWorkflows: {
      providesTags: [TAG_WORKFLOWS_BY_LIST],
    },
    // Routing search results and the unrouted-workflows list live on the
    // `everest` RTK api, which can't be invalidated via `invalidatesTags`
    // from here since tags don't cross api instances — dispatch the
    // equivalent invalidation directly so those caches still refetch after
    // this (still pilot-based, unmigrated) mutation publishes a workflow.
    saveAndPublishWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST],
      onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        queryFulfilled.then(
          () =>
            dispatch(
              everest.util.invalidateTags([
                EVEREST_ROUTING_LIST_TAG,
                EVEREST_WORKFLOWS_LIST_TAG,
              ]),
            ),
          () => {},
        );
      },
    },
  },
});

everest.enhanceEndpoints({
  endpoints: {
    deleteWorkflow: { onQueryStarted: invalidateAvailableWorkflowsOnSuccess },
    duplicateWorkflow: {
      onQueryStarted: invalidateAvailableWorkflowsOnSuccess,
    },
    publishWorkflow: { onQueryStarted: invalidateAvailableWorkflowsOnSuccess },
    unpublishWorkflow: {
      onQueryStarted: invalidateAvailableWorkflowsOnSuccess,
    },
    updateWorkflowShareSettings: {
      onQueryStarted: invalidateAvailableWorkflowsOnSuccess,
    },
  },
});
